// // src/pages/Tasks/TaskEdit.tsx
// import React, { useState, useEffect, useCallback } from 'react';
// import { tasksApi, Task, TaskUpdatePayload, TaskType } from '../../api/tasks';
// import { clientsApi, Client } from '../../api/clients';
// import { getAllUsers } from '../../api/user';
// import { usePermissionGuard } from '../../hooks/usePermissionGuard';

// interface TaskEditProps {
//   isOpen: boolean;
//   task: Task | null;
//   onClose: () => void;
//   onSuccess?: () => void;
// }

// interface User {
//   id: string;
//   user_id?: string;
//   name: string;
//   email: string;
//   role?: string;
//   department?: string;
//   department_id?: string;
//   employee_id?: string;
// }

// interface ApprovalLevel {
//   level: number;
//   approver: string;
//   roleLabel: string;
//   status: string;
//   actionAt: string | null;
//   remark: string;
// }

// type EditFormData = TaskUpdatePayload & { approvalChain?: ApprovalLevel[] };

// function buildFormFromTask(task: Task): EditFormData {
//   return {
//     title: task.title || '',
//     description: task.description || '',
//     task_type: task.task_type || 'GENERAL',
//     tags: task.tags || [],
//     priority: (task.priority as any) || 'MEDIUM',
//     department_id: task.department_id || '',
//     start_date: task.start_date ? task.start_date.split('T')[0] : '',
//     due_date: task.due_date ? task.due_date.slice(0, 16) : '',
//     estimated_hours: task.estimated_hours ?? undefined,
//     actual_hours: task.actual_hours ?? undefined,
//     progress_percent: task.progress_percent ?? undefined,
//     client_id: task.client_id ?? null,
//     assignees: [],
//     checklist: [],
//     replace_checklist: true,
//     replace_assignees: true,
//     approvalChain: [],
//   };
// }

// function TaskEdit({ isOpen, task, onClose, onSuccess }: TaskEditProps) {
//   const { showError, showSuccess } = usePermissionGuard();
//   const [loading, setLoading] = useState(false);
//   const [activeSection, setActiveSection] = useState<'basic' | 'details' | 'approval' | 'checklist'>('basic');

//   const [taskTypes, setTaskTypes] = useState<TaskType[]>([]);
//   const [loadingTaskTypes, setLoadingTaskTypes] = useState(false);
//   const [showCreateTaskTypeModal, setShowCreateTaskTypeModal] = useState(false);
//   const [newTaskTypeName, setNewTaskTypeName] = useState('');
//   const [creatingTaskType, setCreatingTaskType] = useState(false);

//   const [users, setUsers] = useState<User[]>([]);
//   const [loadingUsers, setLoadingUsers] = useState(false);

//   const [clients, setClients] = useState<Client[]>([]);
//   const [showAddClientModal, setShowAddClientModal] = useState(false);
//   const [newClientForm, setNewClientForm] = useState({ clientName: '', email: '', phone: '', address1: '', address2: '', state: '', country: '', pincode: '', gstin: '', pan: '' });
//   const [savingClient, setSavingClient] = useState(false);

//   const [selectedPreparors, setSelectedPreparors] = useState<string[]>([]);
//   const [checklistItems, setChecklistItems] = useState<string[]>([]);

//   const [formData, setFormData] = useState<EditFormData>(
//     task ? buildFormFromTask(task) : { title: '', priority: 'MEDIUM', assignees: [], checklist: [] }
//   );

//   useEffect(() => {
//     if (!isOpen || !task) return;

//     setFormData(buildFormFromTask(task));
//     setSelectedPreparors([]);
//     setChecklistItems([]);
//     setActiveSection('basic');

//     fetchTaskTypes();
//     fetchUsers();
//     clientsApi.list({ page_size: 200 }).then(r => setClients(r.data?.items || [])).catch(() => {});

//     // Load full task detail to pre-populate assignees and checklist
//     tasksApi.get(task.id).then((res: any) => {
//       const detail = res.data;

//       // Pre-populate preparors from PREPAROR-role assignees
//       const preparors: string[] = (detail?.assignees || [])
//         .filter((a: any) => a.role_in_task === 'PREPAROR')
//         .map((a: any) => a.user_id);
//       setSelectedPreparors(preparors.length > 0 ? preparors : []);

//       // Pre-populate approval chain from REVIEWER-role assignees
//       const reviewers: ApprovalLevel[] = (detail?.assignees || [])
//         .filter((a: any) => a.role_in_task === 'REVIEWER')
//         .map((a: any, idx: number) => ({
//           level: idx + 1,
//           approver: a.user_id,
//           roleLabel: 'Reviewer',
//           status: 'Pending',
//           actionAt: null,
//           remark: '',
//         }));
//       setFormData(prev => ({
//         ...prev,
//         approvalChain: reviewers.length > 0
//           ? reviewers
//           : [{ level: 1, approver: '', roleLabel: 'Reviewer', status: 'Pending', actionAt: null, remark: '' }],
//       }));

//       // Pre-populate checklist from existing items
//       const items: string[] = (detail?.checklist || []).map((i: any) => i.item);
//       setChecklistItems(items.length > 0 ? items : []);
//     }).catch(() => {
//       // fallback: empty approval chain with one slot
//       setFormData(prev => ({
//         ...prev,
//         approvalChain: [{ level: 1, approver: '', roleLabel: 'Reviewer', status: 'Pending', actionAt: null, remark: '' }],
//       }));
//     });
//   }, [isOpen, task?.id]);

//   const fetchTaskTypes = async () => {
//     setLoadingTaskTypes(true);
//     try {
//       const response = await tasksApi.getTaskTypes();
//       setTaskTypes(Array.isArray(response.data?.items) ? response.data.items : []);
//     } catch {
//       setTaskTypes([]);
//     } finally {
//       setLoadingTaskTypes(false);
//     }
//   };

//   const fetchUsers = async () => {
//     setLoadingUsers(true);
//     try {
//       const response = await getAllUsers();
//       setUsers(response?.users || []);
//     } catch {
//       setUsers([]);
//     } finally {
//       setLoadingUsers(false);
//     }
//   };

//   const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
//     const { name, value, type } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: type === 'number' ? (value ? parseFloat(value) : undefined) : value,
//     }));
//   };

//   const handleTaskTypeChange = (value: string) => {
//     if (value === '__CREATE_NEW__') {
//       setShowCreateTaskTypeModal(true);
//     } else {
//       setFormData(prev => ({ ...prev, task_type: value }));
//     }
//   };

//   const handleCreateTaskType = async () => {
//     if (!newTaskTypeName.trim()) return;
//     setCreatingTaskType(true);
//     try {
//       const response = await tasksApi.createTaskType({ name: newTaskTypeName });
//       const newType = response.data;
//       setTaskTypes(prev => [...(Array.isArray(prev) ? prev : []), newType]);
//       setFormData(prev => ({ ...prev, task_type: newType.name }));
//       setShowCreateTaskTypeModal(false);
//       setNewTaskTypeName('');
//     } catch (error: any) {
//       alert(error?.response?.data?.message || error?.message || 'Failed to create task type');
//     } finally {
//       setCreatingTaskType(false);
//     }
//   };

//   const addPreparor = () => setSelectedPreparors(prev => [...prev, '']);
//   const removePreparor = (index: number) => setSelectedPreparors(prev => prev.filter((_, i) => i !== index));
//   const updatePreparor = (index: number, userId: string) => {
//     setSelectedPreparors(prev => { const n = [...prev]; n[index] = userId; return n; });
//   };

//   const addApprovalLevel = () => {
//     setFormData(prev => ({
//       ...prev,
//       approvalChain: [
//         ...(prev.approvalChain || []),
//         {
//           level: (prev.approvalChain?.length || 0) + 1,
//           approver: '',
//           roleLabel: `Level ${(prev.approvalChain?.length || 0) + 1} Approver`,
//           status: 'Pending',
//           actionAt: null,
//           remark: '',
//         },
//       ],
//     }));
//   };

//   const removeApprovalLevel = (index: number) => {
//     setFormData(prev => ({
//       ...prev,
//       approvalChain: (prev.approvalChain || []).filter((_, i) => i !== index),
//     }));
//   };

//   const updateApprovalLevel = (index: number, field: keyof ApprovalLevel, value: string) => {
//     setFormData(prev => ({
//       ...prev,
//       approvalChain: (prev.approvalChain || []).map((level, i) =>
//         i === index ? { ...level, [field]: value } : level
//       ),
//     }));
//   };

//   const handleChecklistChange = useCallback((index: number, value: string) => {
//     setChecklistItems(prev => { const n = [...prev]; n[index] = value; return n; });
//   }, []);

//   const addChecklistItem = useCallback(() => {
//     setChecklistItems(prev => [...prev, '']);
//   }, []);

//   const removeChecklistItem = useCallback((index: number) => {
//     setChecklistItems(prev => prev.filter((_, i) => i !== index));
//   }, []);

//   const handleSaveNewClient = async () => {
//     if (!newClientForm.clientName.trim()) return;
//     setSavingClient(true);
//     try {
//       const r = await clientsApi.create({
//         clientName: newClientForm.clientName.trim(),
//         email: newClientForm.email || undefined,
//         phone: newClientForm.phone || undefined,
//         address1: newClientForm.address1 || undefined,
//         address2: newClientForm.address2 || undefined,
//         state: newClientForm.state || undefined,
//         country: newClientForm.country || undefined,
//         pincode: newClientForm.pincode || undefined,
//         gstin: newClientForm.gstin || undefined,
//         pan: newClientForm.pan || undefined,
//       });
//       const created = r.data?.client;
//       if (created) {
//         setClients(prev => [...prev, created]);
//         setFormData(prev => ({ ...prev, client_id: created.id }));
//       }
//       setNewClientForm({ clientName: '', email: '', phone: '', address1: '', address2: '', state: '', country: '', pincode: '', gstin: '', pan: '' });
//       setShowAddClientModal(false);
//     } catch {
//     } finally {
//       setSavingClient(false);
//     }
//   };

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
//     if (!task) return;

//     setLoading(true);

//     const assignees: Array<{ user_id: string; role_in_task: 'PREPAROR' | 'REVIEWER' }> = [];

//     selectedPreparors.forEach(preparorId => {
//       if (preparorId) {
//         assignees.push({ user_id: preparorId, role_in_task: 'PREPAROR' });
//       }
//     });

//     (formData.approvalChain || []).forEach(level => {
//       if (level.approver) {
//         assignees.push({ user_id: level.approver, role_in_task: 'REVIEWER' });
//       }
//     });

//     const filteredChecklist = checklistItems.filter(item => item.trim());

//     const payload: TaskUpdatePayload = {
//       title: formData.title || undefined,
//       description: formData.description || undefined,
//       task_type: formData.task_type || undefined,
//       tags: (formData.tags || []).filter(t => t.trim()),
//       priority: formData.priority,
//       department_id: formData.department_id || undefined,
//       start_date: formData.start_date || undefined,
//       due_date: formData.due_date || undefined,
//       estimated_hours: formData.estimated_hours,
//       actual_hours: formData.actual_hours,
//       progress_percent: formData.progress_percent,
//       client_id: formData.client_id ?? null,
//       // Always send full assignee list with replace so the form state is authoritative
//       assignees,
//       replace_assignees: true,
//       // Always send full checklist with replace so removals/edits are reflected
//       checklist: filteredChecklist,
//       replace_checklist: true,
//     };

//     try {
//       await tasksApi.update(task.id, payload);
//       showSuccess('Task Updated', 'Task has been updated successfully');
//       onClose();
//       onSuccess?.();
//     } catch (err: any) {
//       showError('CANNOT_MODIFY_OTHERS_TASK', err?.response?.data?.detail || err.message || 'Failed to update task');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const isBasicValid = (formData.title || '').trim().length > 0;

//   const getUserName = (userId: string) => {
//     const user = users.find(u => u.id === userId || u.user_id === userId);
//     if (user) {
//       const dept = user.department || user.department_id || '';
//       return `${user.name}${dept ? ` (${dept})` : ''}`;
//     }
//     return '-- Select --';
//   };

//   if (!isOpen || !task) return null;

//   return (
//     <>
//       {/* Backdrop */}
//       <div
//         className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 transition-opacity duration-300"
//         onClick={onClose}
//       />

//       {/* Modal */}
//       <div className="fixed inset-0 z-50 overflow-y-auto">
//         <div className="flex min-h-full items-center justify-center p-4">
//           <div
//             className="relative bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-hidden animate-in fade-in zoom-in duration-300"
//             onClick={e => e.stopPropagation()}
//           >
//             {/* Header */}
//             <div className="sticky top-0 bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-gray-200 px-6 py-5">
//               <div className="flex justify-between items-start">
//                 <div className="flex items-center gap-2">
//                   <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl flex items-center justify-center shadow-md">
//                     <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
//                     </svg>
//                   </div>
//                   <div>
//                     <h2 className="text-xl font-bold text-gray-900">Edit Task</h2>
//                     <p className="text-sm text-gray-500">Update task details</p>
//                   </div>
//                 </div>
//                 <button onClick={onClose} className="p-2 hover:bg-white/50 rounded-lg transition-colors">
//                   <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                   </svg>
//                 </button>
//               </div>
//             </div>

//             {/* Step Indicator */}
//             <div className="px-6 pt-4 border-b border-gray-100">
//               <div className="flex gap-2 overflow-x-auto">
//                 {(['basic', 'details', 'approval', 'checklist'] as const).map((section, idx) => (
//                   <button
//                     key={section}
//                     onClick={() => setActiveSection(section)}
//                     className={`px-4 py-2 text-sm font-medium rounded-t-lg transition-all duration-200 whitespace-nowrap ${
//                       activeSection === section
//                         ? 'bg-white text-blue-600 border-b-2 border-blue-600 shadow-sm'
//                         : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
//                     }`}
//                   >
//                     <span className="flex items-center gap-2">
//                       <span className={`w-5 h-5 rounded-full flex items-center justify-center text-xs ${
//                         activeSection === section ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-500'
//                       }`}>
//                         {idx + 1}
//                       </span>
//                       {section === 'approval' ? 'Approval Chain' : section.charAt(0).toUpperCase() + section.slice(1)}
//                     </span>
//                   </button>
//                 ))}
//               </div>
//             </div>

//             {/* Form Body */}
//             <div className="overflow-y-auto max-h-[calc(90vh-160px)] p-6">
//               <form onSubmit={handleSubmit} className="space-y-5">

//                 {/* Basic Section */}
//                 {activeSection === 'basic' && (
//                   <div className="space-y-5 animate-in fade-in duration-300">
//                     <div>
//                       <label className="block text-sm font-semibold text-gray-700 mb-1.5">
//                         Task Title <span className="text-red-500">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         name="title"
//                         value={formData.title}
//                         onChange={handleChange}
//                         required
//                         maxLength={500}
//                         className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//                         autoFocus
//                       />
//                       <p className="text-xs text-gray-400 mt-1">{(formData.title || '').length}/500 characters</p>
//                     </div>

//                     <div>
//                       <label className="block text-sm font-semibold text-gray-700 mb-1.5">Description</label>
//                       <textarea
//                         name="description"
//                         value={formData.description}
//                         onChange={handleChange}
//                         rows={4}
//                         className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"
//                       />
//                     </div>

//                     {/* Progress & Actual Hours (edit-only fields) */}
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                       <div>
//                         <label className="block text-sm font-semibold text-gray-700 mb-1.5">Actual Hours</label>
//                         <input
//                           type="number"
//                           name="actual_hours"
//                           value={formData.actual_hours || ''}
//                           onChange={handleChange}
//                           step="0.5"
//                           min="0"
//                           className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//                         />
//                       </div>
//                       <div>
//                         <label className="block text-sm font-semibold text-gray-700 mb-1.5">
//                           Progress <span className="text-blue-600 font-bold">{formData.progress_percent ?? 0}%</span>
//                         </label>
//                         <input
//                           type="range"
//                           name="progress_percent"
//                           value={formData.progress_percent ?? 0}
//                           onChange={handleChange}
//                           min="0"
//                           max="100"
//                           className="w-full mt-2"
//                         />
//                       </div>
//                     </div>

//                     <div className="flex justify-end pt-4">
//                       <button
//                         type="button"
//                         onClick={() => setActiveSection('details')}
//                         disabled={!isBasicValid}
//                         className="px-5 py-2.5 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg hover:from-blue-600 hover:to-purple-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed font-medium flex items-center gap-2 shadow-md"
//                       >
//                         Next: Details
//                         <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//                         </svg>
//                       </button>
//                     </div>
//                   </div>
//                 )}

//                 {/* Details Section */}
//                 {activeSection === 'details' && (
//                   <div className="space-y-5 animate-in fade-in duration-300">
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                       <div>
//                         <label className="block text-sm font-semibold text-gray-700 mb-1.5">Task Type</label>
//                         <select
//                           value={formData.task_type}
//                           onChange={e => handleTaskTypeChange(e.target.value)}
//                           className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//                           disabled={loadingTaskTypes}
//                         >
//                           {loadingTaskTypes ? (
//                             <option>Loading...</option>
//                           ) : (
//                             <>
//                               {taskTypes.length > 0 && (
//                                 <optgroup>
//                                   {taskTypes.map(type => (
//                                     <option key={type.id} value={type.name}>{type.name}</option>
//                                   ))}
//                                 </optgroup>
//                               )}
//                               <option disabled style={{ backgroundColor: '#f0f0f0', color: '#999' }}>──────────</option>
//                               <option value="__CREATE_NEW__" style={{ backgroundColor: '#f0f9ff', color: '#3b82f6', fontWeight: 'bold' }}>
//                                 ➕ Create New Type
//                               </option>
//                             </>
//                           )}
//                         </select>
//                       </div>

//                       <div>
//                         <label className="block text-sm font-semibold text-gray-700 mb-1.5">Priority</label>
//                         <select
//                           name="priority"
//                           value={formData.priority}
//                           onChange={handleChange}
//                           className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//                         >
//                           <option value="LOW">🟢 Low</option>
//                           <option value="MEDIUM">🟡 Medium</option>
//                           <option value="HIGH">🟠 High</option>
//                           <option value="URGENT">🔴 Urgent</option>
//                         </select>
//                       </div>
//                     </div>

//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                       <div>
//                         <label className="block text-sm font-semibold text-gray-700 mb-1.5">Due Date</label>
//                         <input
//                           type="datetime-local"
//                           name="due_date"
//                           value={formData.due_date || ''}
//                           onChange={handleChange}
//                           className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//                         />
//                       </div>

//                       <div>
//                         <div className="flex justify-between items-center mb-1.5">
//                           <label className="block text-sm font-semibold text-gray-700">Client <span className="text-gray-400 font-normal">(optional)</span></label>
//                           <button
//                             type="button"
//                             onClick={() => setShowAddClientModal(true)}
//                             className="text-xs text-indigo-600 hover:text-indigo-800 font-medium flex items-center gap-1"
//                           >
//                             <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
//                             </svg>
//                             New Client
//                           </button>
//                         </div>
//                         <select
//                           value={formData.client_id || ''}
//                           onChange={e => setFormData(prev => ({ ...prev, client_id: e.target.value || null }))}
//                           className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//                         >
//                           <option value="">No client</option>
//                           {clients.map(c => (
//                             <option key={c.id} value={c.id}>{c.clientName}{c.state ? ` — ${c.state}` : ''}</option>
//                           ))}
//                         </select>
//                       </div>
//                     </div>

//                     <div>
//                       <label className="block text-sm font-semibold text-gray-700 mb-1.5">Estimated Hours</label>
//                       <input
//                         type="number"
//                         name="estimated_hours"
//                         value={formData.estimated_hours || ''}
//                         onChange={handleChange}
//                         step="0.5"
//                         min="0"
//                         className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//                       />
//                     </div>

//                     <div className="flex justify-between pt-4">
//                       <button
//                         type="button"
//                         onClick={() => setActiveSection('basic')}
//                         className="px-5 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium flex items-center gap-2"
//                       >
//                         <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//                         </svg>
//                         Back
//                       </button>
//                       <button
//                         type="button"
//                         onClick={() => setActiveSection('approval')}
//                         className="px-5 py-2.5 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg hover:from-blue-600 hover:to-purple-700 transition-all font-medium flex items-center gap-2 shadow-md"
//                       >
//                         Next: Approval Chain
//                         <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//                         </svg>
//                       </button>
//                     </div>
//                   </div>
//                 )}

//                 {/* Approval Chain Section */}
//                 {activeSection === 'approval' && (
//                   <div className="space-y-5 animate-in fade-in duration-300">
//                     {/* Preparors */}
//                     <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-5 border border-blue-200">
//                       <div className="flex justify-between items-center mb-3">
//                         <div>
//                           <div className="flex items-center gap-2">
//                             <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center text-white text-xs font-bold">1</div>
//                             <h3 className="font-semibold text-gray-900">Add Preparors (Workers)</h3>
//                           </div>
//                           <p className="text-xs text-gray-500 mt-1">Optionally add more people who will do the work</p>
//                         </div>
//                         <button
//                           type="button"
//                           onClick={addPreparor}
//                           className="px-3 py-1.5 bg-blue-500 text-white text-xs rounded-lg hover:bg-blue-600 transition-colors flex items-center gap-1"
//                         >
//                           <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
//                           </svg>
//                           Add Preparor
//                         </button>
//                       </div>

//                       <div className="space-y-2">
//                         {selectedPreparors.length === 0 ? (
//                           <button
//                             type="button"
//                             onClick={addPreparor}
//                             className="w-full py-3 border-2 border-dashed border-blue-300 rounded-lg text-blue-600 text-sm hover:border-blue-400 hover:bg-blue-50 transition-colors"
//                           >
//                             + Click to add a preparor
//                           </button>
//                         ) : (
//                           selectedPreparors.map((preparorId, idx) => (
//                             <div key={idx} className="flex gap-2 items-center group">
//                               <div className="w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center text-xs text-blue-600 font-medium">
//                                 {idx + 1}
//                               </div>
//                               <select
//                                 value={preparorId}
//                                 onChange={e => updatePreparor(idx, e.target.value)}
//                                 className="flex-1 px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//                                 disabled={loadingUsers}
//                               >
//                                 <option value="">-- Select Preparor --</option>
//                                 {users.map(user => (
//                                   <option key={user.id || user.user_id} value={user.id || user.user_id}>
//                                     {user.name} {user.role ? `(${user.role})` : ''}
//                                   </option>
//                                 ))}
//                               </select>
//                               <button
//                                 type="button"
//                                 onClick={() => removePreparor(idx)}
//                                 className="opacity-0 group-hover:opacity-100 p-2 bg-red-100 text-red-600 rounded-lg hover:bg-red-200 transition-all"
//                               >
//                                 <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                                 </svg>
//                               </button>
//                             </div>
//                           ))
//                         )}
//                       </div>
//                     </div>

//                     {/* Approval Chain */}
//                     <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
//                       <div className="flex justify-between items-center mb-4">
//                         <div>
//                           <div className="flex items-center gap-2">
//                             <div className="w-6 h-6 bg-purple-500 rounded-full flex items-center justify-center text-white text-xs font-bold">2</div>
//                             <h3 className="font-semibold text-gray-900">Approval Chain</h3>
//                           </div>
//                           <p className="text-xs text-gray-500 mt-1">Add reviewers for this task</p>
//                         </div>
//                         <button
//                           type="button"
//                           onClick={addApprovalLevel}
//                           className="px-3 py-1.5 bg-purple-500 text-white text-xs rounded-lg hover:bg-purple-600 transition-colors flex items-center gap-1"
//                         >
//                           <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
//                           </svg>
//                           Add Level
//                         </button>
//                       </div>

//                       <div className="space-y-3">
//                         {(formData.approvalChain || []).map((level, idx) => (
//                           <div key={idx} className="bg-white rounded-lg p-4 border border-gray-200">
//                             <div className="flex items-center justify-between mb-3">
//                               <div className="flex items-center gap-2">
//                                 <div className="w-6 h-6 rounded-full bg-purple-100 text-purple-600 text-xs font-bold flex items-center justify-center">
//                                   {level.level}
//                                 </div>
//                                 <span className="font-medium text-gray-700">Level {level.level} Approval</span>
//                               </div>
//                               <button
//                                 type="button"
//                                 onClick={() => removeApprovalLevel(idx)}
//                                 className="text-red-500 hover:text-red-700 text-xs px-2 py-1 rounded hover:bg-red-50"
//                               >
//                                 Remove
//                               </button>
//                             </div>
//                             <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//                               <div>
//                                 <label className="block text-xs font-medium text-gray-600 mb-1">Who Will Approve</label>
//                                 <select
//                                   value={level.approver}
//                                   onChange={e => updateApprovalLevel(idx, 'approver', e.target.value)}
//                                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 text-sm"
//                                   disabled={loadingUsers}
//                                 >
//                                   <option value="">-- Select --</option>
//                                   {users.map(user => (
//                                     <option key={user.id || user.user_id} value={user.id || user.user_id}>
//                                       {user.name} {user.role ? `(${user.role})` : ''}
//                                     </option>
//                                   ))}
//                                 </select>
//                               </div>
//                               <div>
//                                 <label className="block text-xs font-medium text-gray-600 mb-1">Role Label</label>
//                                 <input
//                                   type="text"
//                                   value={level.roleLabel}
//                                   onChange={e => updateApprovalLevel(idx, 'roleLabel', e.target.value)}
//                                   placeholder="e.g., Accounts Reviewer"
//                                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 text-sm"
//                                 />
//                               </div>
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>

//                     <div className="flex justify-between pt-4">
//                       <button
//                         type="button"
//                         onClick={() => setActiveSection('details')}
//                         className="px-5 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium flex items-center gap-2"
//                       >
//                         <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//                         </svg>
//                         Back
//                       </button>
//                       <button
//                         type="button"
//                         onClick={() => setActiveSection('checklist')}
//                         className="px-5 py-2.5 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg hover:from-blue-600 hover:to-purple-700 transition-all font-medium flex items-center gap-2 shadow-md"
//                       >
//                         Next: Checklist
//                         <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//                         </svg>
//                       </button>
//                     </div>
//                   </div>
//                 )}

//                 {/* Checklist Section */}
//                 {activeSection === 'checklist' && (
//                   <div className="space-y-5 animate-in fade-in duration-300">
//                     <div>
//                       <div className="flex justify-between items-center mb-2">
//                         <label className="block text-sm font-semibold text-gray-700">Checklist Items</label>
//                         <span className="text-xs text-gray-400">
//                           {checklistItems.filter(i => i.trim()).length} item(s)
//                         </span>
//                       </div>
//                       {checklistItems.length === 0 && (
//                         <p className="text-sm text-gray-400 italic mb-2">No checklist items yet. Click below to add.</p>
//                       )}
//                       <div className="space-y-2 max-h-64 overflow-y-auto pr-2">
//                         {checklistItems.map((item, index) => (
//                           <div key={index} className="flex gap-2 items-center group">
//                             <div className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center text-xs text-gray-500">
//                               {index + 1}
//                             </div>
//                             <input
//                               type="text"
//                               value={item}
//                               onChange={e => handleChecklistChange(index, e.target.value)}
//                               placeholder={`Task item ${index + 1}`}
//                               className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
//                             />
//                             <button
//                               type="button"
//                               onClick={() => removeChecklistItem(index)}
//                               className="opacity-0 group-hover:opacity-100 p-2 bg-red-100 text-red-600 rounded-lg hover:bg-red-200 transition-all"
//                             >
//                               <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                               </svg>
//                             </button>
//                           </div>
//                         ))}
//                       </div>
//                       <button
//                         type="button"
//                         onClick={addChecklistItem}
//                         className="mt-3 text-blue-600 hover:text-blue-700 text-sm font-medium flex items-center gap-1"
//                       >
//                         <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
//                         </svg>
//                         Add Checklist Item
//                       </button>
//                     </div>

//                     {/* Summary */}
//                     <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-4 border border-green-200">
//                       <h4 className="font-semibold text-gray-800 text-sm mb-2">📋 Update Summary</h4>
//                       <div className="space-y-1 text-xs text-gray-600">
//                         <p><strong>Title:</strong> {formData.title || 'Not set'}</p>
//                         <p><strong>Priority:</strong> {formData.priority || 'Not set'}</p>
//                         <p><strong>Preparors:</strong> {selectedPreparors.filter(p => p).length > 0 ? selectedPreparors.filter(p => p).map(p => getUserName(p)).join(', ') : 'None'}</p>
//                         <p><strong>Reviewers:</strong> {(formData.approvalChain || []).filter(l => l.approver).length}</p>
//                         <p><strong>Checklist Items:</strong> {checklistItems.filter(i => i.trim()).length}</p>
//                       </div>
//                     </div>

//                     <div className="flex justify-between pt-4">
//                       <button
//                         type="button"
//                         onClick={() => setActiveSection('approval')}
//                         className="px-5 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium flex items-center gap-2"
//                       >
//                         <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//                         </svg>
//                         Back
//                       </button>
//                       <div className="flex gap-3">
//                         <button
//                           type="button"
//                           onClick={onClose}
//                           className="px-5 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium"
//                         >
//                           Cancel
//                         </button>
//                         <button
//                           type="submit"
//                           disabled={loading || !isBasicValid}
//                           className="px-6 py-2.5 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed font-medium flex items-center gap-2 shadow-md"
//                         >
//                           {loading ? (
//                             <>
//                               <svg className="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
//                                 <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//                                 <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
//                               </svg>
//                               Saving...
//                             </>
//                           ) : (
//                             <>
//                               <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
//                               </svg>
//                               Save Changes
//                             </>
//                           )}
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Create Task Type Modal */}
//       {showCreateTaskTypeModal && (
//         <>
//           <div
//             className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[110]"
//             onClick={() => setShowCreateTaskTypeModal(false)}
//           />
//           <div className="fixed inset-0 z-[110] overflow-y-auto">
//             <div className="flex min-h-full items-center justify-center p-4">
//               <div
//                 className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md animate-in fade-in zoom-in duration-300"
//                 onClick={e => e.stopPropagation()}
//               >
//                 <div className="p-6">
//                   <div className="flex justify-between items-center mb-4">
//                     <div className="flex items-center gap-2">
//                       <div className="w-8 h-8 bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl flex items-center justify-center shadow-md">
//                         <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l5 5a2 2 0 01.586 1.414V19a2 2 0 01-2 2H7a2 2 0 01-2-2V5a2 2 0 012-2z" />
//                         </svg>
//                       </div>
//                       <h3 className="text-lg font-bold text-gray-900">Create Task Type</h3>
//                     </div>
//                     <button onClick={() => setShowCreateTaskTypeModal(false)} className="p-1 hover:bg-gray-100 rounded-lg">
//                       <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                       </svg>
//                     </button>
//                   </div>
//                   <div className="space-y-4">
//                     <div>
//                       <label className="block text-sm font-semibold text-gray-700 mb-1.5">
//                         Type Name <span className="text-red-500">*</span>
//                       </label>
//                       <input
//                         type="text"
//                         value={newTaskTypeName}
//                         onChange={e => setNewTaskTypeName(e.target.value)}
//                         placeholder="e.g., Documentation, Research, Testing"
//                         className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-colors"
//                         autoFocus
//                         onKeyPress={e => { if (e.key === 'Enter') handleCreateTaskType(); }}
//                       />
//                     </div>
//                     <div className="flex gap-3 pt-4">
//                       <button
//                         type="button"
//                         onClick={() => setShowCreateTaskTypeModal(false)}
//                         className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium"
//                       >
//                         Cancel
//                       </button>
//                       <button
//                         type="button"
//                         onClick={handleCreateTaskType}
//                         disabled={creatingTaskType || !newTaskTypeName.trim()}
//                         className="flex-1 px-4 py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg hover:from-purple-600 hover:to-pink-600 transition-all disabled:opacity-50 font-medium flex items-center justify-center gap-2 shadow-md"
//                       >
//                         {creatingTaskType ? (
//                           <>
//                             <svg className="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
//                               <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//                               <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
//                             </svg>
//                             Creating...
//                           </>
//                         ) : (
//                           <>
//                             <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
//                             </svg>
//                             Create Type
//                           </>
//                         )}
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </>
//       )}

//       {/* Quick Add Client Modal */}
//       {showAddClientModal && (
//         <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[110] flex items-center justify-center p-4" onClick={() => setShowAddClientModal(false)}>
//           <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md" onClick={e => e.stopPropagation()}>
//             <div className="p-5 border-b border-gray-100 flex items-center gap-3">
//               <div className="w-9 h-9 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center">
//                 <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0M12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
//                 </svg>
//               </div>
//               <div>
//                 <h3 className="font-bold text-gray-900">Add New Client</h3>
//                 <p className="text-xs text-gray-500">Quick add — full details in Client panel</p>
//               </div>
//             </div>
//             <div className="p-5 space-y-3">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Client Name <span className="text-red-500">*</span></label>
//                 <input type="text" value={newClientForm.clientName} onChange={e => setNewClientForm(f => ({ ...f, clientName: e.target.value }))}
//                   placeholder="e.g., Acme Corporation" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 text-sm" autoFocus />
//               </div>
//               <div className="grid grid-cols-2 gap-3">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
//                   <input type="email" value={newClientForm.email} onChange={e => setNewClientForm(f => ({ ...f, email: e.target.value }))}
//                     placeholder="email@co.com" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 text-sm" />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
//                   <input type="tel" value={newClientForm.phone} onChange={e => setNewClientForm(f => ({ ...f, phone: e.target.value }))}
//                     placeholder="+91..." className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 text-sm" />
//                 </div>
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Address Line 1</label>
//                 <input type="text" value={newClientForm.address1} onChange={e => setNewClientForm(f => ({ ...f, address1: e.target.value }))}
//                   placeholder="Street address" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 text-sm" />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">Address Line 2</label>
//                 <input type="text" value={newClientForm.address2} onChange={e => setNewClientForm(f => ({ ...f, address2: e.target.value }))}
//                   placeholder="Area, landmark…" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 text-sm" />
//               </div>
//               <div className="grid grid-cols-3 gap-3">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">State</label>
//                   <input type="text" value={newClientForm.state} onChange={e => setNewClientForm(f => ({ ...f, state: e.target.value }))}
//                     placeholder="State" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 text-sm" />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">Country</label>
//                   <input type="text" value={newClientForm.country} onChange={e => setNewClientForm(f => ({ ...f, country: e.target.value }))}
//                     placeholder="Country" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 text-sm" />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">Pincode</label>
//                   <input type="text" value={newClientForm.pincode} onChange={e => setNewClientForm(f => ({ ...f, pincode: e.target.value }))}
//                     placeholder="000000" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 text-sm" />
//                 </div>
//               </div>
//               <div className="grid grid-cols-2 gap-3 pt-1 border-t border-gray-100">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">GSTIN</label>
//                   <input type="text" value={newClientForm.gstin} onChange={e => setNewClientForm(f => ({ ...f, gstin: e.target.value.toUpperCase() }))}
//                     placeholder="22AAAAA0000A1Z5" maxLength={15} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 text-sm font-mono" />
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">PAN</label>
//                   <input type="text" value={newClientForm.pan} onChange={e => setNewClientForm(f => ({ ...f, pan: e.target.value.toUpperCase() }))}
//                     placeholder="AAAAA0000A" maxLength={10} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 text-sm font-mono" />
//                 </div>
//               </div>
//             </div>
//             <div className="p-5 border-t border-gray-100 flex gap-3 justify-end">
//               <button onClick={() => setShowAddClientModal(false)} className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 text-sm font-medium">Cancel</button>
//               <button onClick={handleSaveNewClient} disabled={savingClient || !newClientForm.clientName.trim()}
//                 className="px-5 py-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg hover:from-indigo-700 hover:to-purple-700 transition-all text-sm font-medium disabled:opacity-50">
//                 {savingClient ? 'Adding…' : 'Add Client'}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <style>{`
//         @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
//         @keyframes zoomIn { from { transform: scale(0.95); opacity: 0; } to { transform: scale(1); opacity: 1; } }
//         .animate-in { animation-duration: 0.3s; animation-fill-mode: both; }
//         .fade-in { animation-name: fadeIn; }
//         .zoom-in { animation-name: zoomIn; }
//       `}</style>
//     </>
//   );
// }

// export default TaskEdit;


// src/pages/Tasks/TaskEdit.tsx
import React, { useState, useEffect, useCallback } from 'react';
import { tasksApi, Task, TaskUpdatePayload, TaskType } from '../../api/tasks';
import { clientsApi, Client } from '../../api/clients';
import { projectsApi, Project } from '../../api/projects';
import { getAllUsers } from '../../api/user';
import { usePermissionGuard } from '../../hooks/usePermissionGuard';
import { format } from "date-fns";
import { createPortal } from 'react-dom';
import { Calendar as CalendarIcon } from "lucide-react";
import { Calendar } from "../../components/ui/calendar";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";

interface TaskEditProps {
  isOpen: boolean;
  task: Task | null;
  onClose: () => void;
  onSuccess?: () => void;
}

interface User {
  id: string;
  user_id?: string;
  name: string;
  email: string;
  role?: string;
  department?: string;
  department_id?: string;
  employee_id?: string;
}

interface ApprovalLevel {
  level: number;
  approver: string;
  roleLabel: string;
  status: string;
  actionAt: string | null;
  remark: string;
}

interface TaskTypeWithDefault extends TaskType {
  is_default?: boolean;
}

type EditFormData = TaskUpdatePayload & { approvalChain?: ApprovalLevel[] };

function buildFormFromTask(task: Task): EditFormData {
  return {
    title: task.title || '',
    description: task.description || '',
    task_type: task.task_type || 'GENERAL',
    tags: task.tags || [],
    priority: (task.priority as any) || 'MEDIUM',
    department_id: task.department_id || '',
    start_date: task.start_date ? task.start_date.split('T')[0] : '',
    due_date: task.due_date ? task.due_date.slice(0, 16) : '',
    estimated_hours: task.estimated_hours ?? undefined,
    actual_hours: task.actual_hours ?? undefined,
    progress_percent: task.progress_percent ?? undefined,
    client_id: task.client_id ?? null,
    project_id: task.project_id ?? null,
    assignees: [],
    checklist: [],
    replace_checklist: true,
    replace_assignees: true,
    approvalChain: [],
  };
}

function TaskEdit({ isOpen, task, onClose, onSuccess }: TaskEditProps) {
  const { showError, showSuccess } = usePermissionGuard();
  const [loading, setLoading] = useState(false);
  const [activeSection, setActiveSection] = useState<'basic' | 'details' | 'approval' | 'checklist'>('basic');

  const [taskTypes, setTaskTypes] = useState<TaskTypeWithDefault[]>([]);
  const [loadingTaskTypes, setLoadingTaskTypes] = useState(false);
  const [showCreateTaskTypeModal, setShowCreateTaskTypeModal] = useState(false);
  const [newTaskTypeName, setNewTaskTypeName] = useState('');
  const [creatingTaskType, setCreatingTaskType] = useState(false);
  const [editingType, setEditingType] = useState<TaskTypeWithDefault | null>(null);
  const [editName, setEditName] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [deleteType, setDeleteType] = useState<TaskTypeWithDefault | null>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showTypeDropdown, setShowTypeDropdown] = useState(false);

  const [users, setUsers] = useState<User[]>([]);
  const [loadingUsers, setLoadingUsers] = useState(false);

  const [clients, setClients] = useState<Client[]>([]);
  const [showAddClientModal, setShowAddClientModal] = useState(false);
  const [newClientForm, setNewClientForm] = useState({ clientName: '', email: '', phone: '', address1: '', address2: '', state: '', country: '', pincode: '', gstin: '', pan: '' });
  const [savingClient, setSavingClient] = useState(false);

  const [projects, setProjects] = useState<Project[]>([]);
  const [showAddProjectModal, setShowAddProjectModal] = useState(false);
  const [newProjectForm, setNewProjectForm] = useState({ name: '', description: '', client_id: '' });
  const [savingProject, setSavingProject] = useState(false);

  const [selectedPreparors, setSelectedPreparors] = useState<string[]>([]);
  const [checklistItems, setChecklistItems] = useState<string[]>([]);

  // Due date states
  const [dueOpen, setDueOpen] = useState(false);
  const [dueDate, setDueDate] = useState<Date | null>(null);
  const [dueTime, setDueTime] = useState<string>("");

  const [formData, setFormData] = useState<EditFormData>(
    task ? buildFormFromTask(task) : { title: '', priority: 'MEDIUM', assignees: [], checklist: [] }
  );

  useEffect(() => {
    if (!isOpen || !task) return;

    setFormData(buildFormFromTask(task));
    setSelectedPreparors([]);
    setChecklistItems([]);
    setActiveSection('basic');

    // Initialize due date from task
    if (task.due_date) {
      const dueDateObj = new Date(task.due_date);
      setDueDate(dueDateObj);
      setDueTime(format(dueDateObj, "HH:mm"));
    } else {
      setDueDate(null);
      setDueTime("");
    }

    fetchTaskTypes();
    fetchUsers();
    clientsApi.list({ page_size: 200 }).then(r => setClients(r.data?.items || [])).catch(() => {});
    projectsApi.list({ page_size: 200 }).then(r => setProjects(r.data?.items || [])).catch(() => {});

    // Load full task detail to pre-populate assignees and checklist
    tasksApi.get(task.id).then((res: any) => {
      const detail = res.data;

      // Pre-populate preparors from PREPAROR-role assignees
      const preparors: string[] = (detail?.assignees || [])
        .filter((a: any) => a.role_in_task === 'PREPAROR')
        .map((a: any) => a.user_id);
      setSelectedPreparors(preparors.length > 0 ? preparors : []);

      // Pre-populate approval chain from REVIEWER-role assignees
      const reviewers: ApprovalLevel[] = (detail?.assignees || [])
        .filter((a: any) => a.role_in_task === 'REVIEWER')
        .map((a: any, idx: number) => ({
          level: idx + 1,
          approver: a.user_id,
          roleLabel: 'Reviewer',
          status: 'Pending',
          actionAt: null,
          remark: '',
        }));
      setFormData(prev => ({
        ...prev,
        approvalChain: reviewers.length > 0
          ? reviewers
          : [{ level: 1, approver: '', roleLabel: 'Reviewer', status: 'Pending', actionAt: null, remark: '' }],
      }));

      // Pre-populate checklist from existing items
      const items: string[] = (detail?.checklist || []).map((i: any) => i.item);
      setChecklistItems(items.length > 0 ? items : []);
    }).catch(() => {
      // fallback: empty approval chain with one slot
      setFormData(prev => ({
        ...prev,
        approvalChain: [{ level: 1, approver: '', roleLabel: 'Reviewer', status: 'Pending', actionAt: null, remark: '' }],
      }));
    });
  }, [isOpen, task?.id]);

  const fetchTaskTypes = async () => {
    setLoadingTaskTypes(true);
    try {
      const response = await tasksApi.getTaskTypes();
      const taskTypesData = Array.isArray(response.data?.items) ? response.data.items : [];
      setTaskTypes(taskTypesData);
    } catch {
      setTaskTypes([]);
    } finally {
      setLoadingTaskTypes(false);
    }
  };

  const fetchUsers = async () => {
    setLoadingUsers(true);
    try {
      const response = await getAllUsers();
      setUsers(response?.users || []);
    } catch {
      setUsers([]);
    } finally {
      setLoadingUsers(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'number' ? (value ? parseFloat(value) : undefined) : value,
    }));
  };

  const handleTaskTypeChange = (value: string) => {
    if (value === '__CREATE_NEW__') {
      setShowCreateTaskTypeModal(true);
    } else {
      setFormData(prev => ({ ...prev, task_type: value }));
    }
  };

  const handleEditType = (type: TaskTypeWithDefault) => {
    setEditingType(type);
    setEditName(type.name);
    setShowEditModal(true);
  };

  const handleDeleteType = (type: TaskTypeWithDefault) => {
    setDeleteType(type);
    setShowDeleteModal(true);
  };

  const handleUpdateTaskType = async () => {
    if (!editingType || !editName.trim()) {
      alert('Please enter a task type name');
      return;
    }

    setCreatingTaskType(true);
    try {
      await tasksApi.updateTaskType(editingType.id, { name: editName.trim() });
      await fetchTaskTypes();
      setShowEditModal(false);
      setEditingType(null);
      setEditName("");
      alert('Task type updated successfully');
    } catch (error: any) {
      alert(error?.response?.data?.message || error?.message || 'Failed to update task type');
    } finally {
      setCreatingTaskType(false);
    }
  };

  const handleDeleteTaskType = async () => {
    if (!deleteType) return;

    setLoading(true);
    try {
      await tasksApi.deleteTaskType(deleteType.id);
      await fetchTaskTypes();

      if (formData.task_type === deleteType.name) {
        setFormData({ ...formData, task_type: '' });
      }

      setShowDeleteModal(false);
      setDeleteType(null);
      alert('Task type deleted successfully');
    } catch (error: any) {
      alert(error?.response?.data?.message || error?.message || 'Failed to delete task type');
    } finally {
      setLoading(false);
    }
  };

  const handleCreateTaskType = async () => {
    if (!newTaskTypeName.trim()) return;
    setCreatingTaskType(true);
    try {
      const response = await tasksApi.createTaskType({ name: newTaskTypeName });
      const newType = response.data;
      setTaskTypes(prev => [...(Array.isArray(prev) ? prev : []), newType]);
      setFormData(prev => ({ ...prev, task_type: newType.name }));
      setShowCreateTaskTypeModal(false);
      setNewTaskTypeName('');
    } catch (error: any) {
      alert(error?.response?.data?.message || error?.message || 'Failed to create task type');
    } finally {
      setCreatingTaskType(false);
    }
  };

  const addPreparor = () => setSelectedPreparors(prev => [...prev, '']);
  const removePreparor = (index: number) => setSelectedPreparors(prev => prev.filter((_, i) => i !== index));
  const updatePreparor = (index: number, userId: string) => {
    setSelectedPreparors(prev => { const n = [...prev]; n[index] = userId; return n; });
  };

  const addApprovalLevel = () => {
    setFormData(prev => ({
      ...prev,
      approvalChain: [
        ...(prev.approvalChain || []),
        {
          level: (prev.approvalChain?.length || 0) + 1,
          approver: '',
          roleLabel: `Level ${(prev.approvalChain?.length || 0) + 1} Approver`,
          status: 'Pending',
          actionAt: null,
          remark: '',
        },
      ],
    }));
  };

  const removeApprovalLevel = (index: number) => {
    setFormData(prev => ({
      ...prev,
      approvalChain: (prev.approvalChain || []).filter((_, i) => i !== index),
    }));
  };

  const updateApprovalLevel = (index: number, field: keyof ApprovalLevel, value: string) => {
    setFormData(prev => ({
      ...prev,
      approvalChain: (prev.approvalChain || []).map((level, i) =>
        i === index ? { ...level, [field]: value } : level
      ),
    }));
  };

  const handleChecklistChange = useCallback((index: number, value: string) => {
    setChecklistItems(prev => { const n = [...prev]; n[index] = value; return n; });
  }, []);

  const addChecklistItem = useCallback(() => {
    setChecklistItems(prev => [...prev, '']);
  }, []);

  const removeChecklistItem = useCallback((index: number) => {
    setChecklistItems(prev => prev.filter((_, i) => i !== index));
  }, []);

  // Due date handlers
  const handleDateSelect = (date: Date | undefined) => {
    if (!date) return;

    const updated = new Date(date);

    if (dueTime) {
      const [h, m] = dueTime.split(":");
      updated.setHours(Number(h));
      updated.setMinutes(Number(m));
    } else {
      updated.setHours(18);
      updated.setMinutes(0);
    }

    setDueDate(updated);
    setFormData((prev) => ({
      ...prev,
      due_date: formatLocalDateTime(updated),
    }));
    setDueOpen(false);
  };

  const handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const time = e.target.value;
    setDueTime(time);

    if (dueDate) {
      const [hours, minutes] = time.split(':');
      const updated = new Date(dueDate);
      updated.setHours(parseInt(hours), parseInt(minutes));
      setDueDate(updated);
      setFormData((prev) => ({
        ...prev,
        due_date: formatLocalDateTime(updated),
      }));
    }
  };

  const formatLocalDateTime = (date: Date) => {
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };

  const handleSaveNewClient = async () => {
    if (!newClientForm.clientName.trim()) return;
    setSavingClient(true);
    try {
      const r = await clientsApi.create({
        clientName: newClientForm.clientName.trim(),
        email: newClientForm.email || undefined,
        phone: newClientForm.phone || undefined,
        address1: newClientForm.address1 || undefined,
        address2: newClientForm.address2 || undefined,
        state: newClientForm.state || undefined,
        country: newClientForm.country || undefined,
        pincode: newClientForm.pincode || undefined,
        gstin: newClientForm.gstin || undefined,
        pan: newClientForm.pan || undefined,
      });
      const created = r.data?.client;
      if (created) {
        setClients(prev => [...prev, created]);
        setFormData(prev => ({ ...prev, client_id: created.id }));
      }
      setNewClientForm({ clientName: '', email: '', phone: '', address1: '', address2: '', state: '', country: '', pincode: '', gstin: '', pan: '' });
      setShowAddClientModal(false);
    } catch {
    } finally {
      setSavingClient(false);
    }
  };

  const handleSaveNewProject = async () => {
    if (!newProjectForm.name.trim()) return;
    setSavingProject(true);
    try {
      const r = await projectsApi.create({
        name: newProjectForm.name.trim(),
        description: newProjectForm.description || undefined,
        client_id: newProjectForm.client_id || null,
      });
      const created = r.data?.project;
      if (created) {
        setProjects(prev => [...prev, created]);
        setFormData(prev => ({
          ...prev,
          project_id: created.id,
          ...(created.client_id ? { client_id: created.client_id } : {}),
        } as any));
      }
      setNewProjectForm({ name: '', description: '', client_id: '' });
      setShowAddProjectModal(false);
    } catch {
    } finally {
      setSavingProject(false);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!task) return;

    setLoading(true);

    const assignees: Array<{ user_id: string; role_in_task: 'PREPAROR' | 'REVIEWER' }> = [];

    selectedPreparors.forEach(preparorId => {
      if (preparorId) {
        assignees.push({ user_id: preparorId, role_in_task: 'PREPAROR' });
      }
    });

    (formData.approvalChain || []).forEach(level => {
      if (level.approver) {
        assignees.push({ user_id: level.approver, role_in_task: 'REVIEWER' });
      }
    });

    const filteredChecklist = checklistItems.filter(item => item.trim());

    const payload: TaskUpdatePayload = {
      title: formData.title || undefined,
      description: formData.description || undefined,
      task_type: formData.task_type || undefined,
      tags: (formData.tags || []).filter(t => t.trim()),
      priority: formData.priority,
      department_id: formData.department_id || undefined,
      start_date: formData.start_date || undefined,
      due_date: formData.due_date || undefined,
      estimated_hours: formData.estimated_hours,
      actual_hours: formData.actual_hours,
      progress_percent: formData.progress_percent,
      client_id: formData.client_id ?? null,
      project_id: (formData as any).project_id ?? null,
      assignees,
      replace_assignees: true,
      checklist: filteredChecklist,
      replace_checklist: true,
    };

    try {
      await tasksApi.update(task.id, payload);
      showSuccess('Task Updated', 'Task has been updated successfully');
      onClose();
      onSuccess?.();
    } catch (err: any) {
      showError('CANNOT_MODIFY_OTHERS_TASK', err?.response?.data?.detail || err.message || 'Failed to update task');
    } finally {
      setLoading(false);
    }
  };

  const isBasicValid = (formData.title || '').trim().length > 0;

  const getUserName = (userId: string) => {
    const user = users.find(u => u.id === userId || u.user_id === userId);
    if (user) {
      const dept = user.department || user.department_id || '';
      return `${user.name}${dept ? ` (${dept})` : ''}`;
    }
    return '-- Select --';
  };

  if (!isOpen || !task) return null;

  return createPortal(
    <div className="gt-themed">
      <div
        className="fixed inset-0 transition-opacity duration-300"
        style={{ background: 'rgba(15, 29, 20, 0.32)', backdropFilter: 'blur(6px)', WebkitBackdropFilter: 'blur(6px)', zIndex: 100 }}
        onClick={onClose}
      />

      <div className="fixed inset-0 overflow-y-auto" style={{ zIndex: 101 }}>
        <div className="flex min-h-full items-center justify-center p-4">
          <div
            className="relative w-full max-w-3xl max-h-[90vh] overflow-hidden gt-modal animate-in fade-in zoom-in duration-300"
            onClick={e => e.stopPropagation()}
          >
            <div className="sticky top-0 px-6 py-5"
              style={{
                background: 'linear-gradient(135deg, var(--gt-primary-container) 0%, var(--gt-surface-1) 100%)',
                borderBottom: '1px solid var(--gt-divider)',
              }}>
              <div className="flex justify-between items-start">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="gt-leaf" style={{ width: 10, height: 10 }} />
                    <span className="gt-eyebrow">i. Refine</span>
                  </div>
                  <h2 className="gt-display" style={{ fontSize: 22 }}>Edit <em className="gt-serif-italic" style={{ color: 'var(--gt-accent-strong)' }}>Task</em></h2>
                  <p className="gt-page-sub" style={{ marginTop: 4 }}>Update <em className="gt-serif-italic">task</em> details.</p>
                </div>
                <button onClick={onClose} className="gt-icon-btn">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>

            {/* Step Indicator — matches Task Reports / All-Tasks tab style */}
            <div className="px-6 pt-3" style={{ borderBottom: '1px solid var(--gt-border)' }}>
              <nav className="flex gap-1 overflow-x-auto flex-wrap">
                {(['basic', 'details', 'approval', 'checklist'] as const).map((section) => {
                  const isActive = activeSection === section;
                  const label = section === 'approval' ? 'Approval Chain' : section.charAt(0).toUpperCase() + section.slice(1);
                  return (
                    <button
                      key={section}
                      type="button"
                      onClick={() => setActiveSection(section)}
                      className="transition-all"
                      style={{
                        padding: '10px 18px',
                        fontFamily: 'var(--gt-font-display)',
                        fontSize: 13,
                        fontWeight: 600,
                        letterSpacing: '0.01em',
                        borderTopLeftRadius: 12,
                        borderTopRightRadius: 12,
                        border: 'none',
                        borderBottom: isActive ? '2px solid var(--gt-primary)' : '2px solid transparent',
                        background: isActive ? 'var(--gt-surface-0)' : 'transparent',
                        color: isActive ? 'var(--gt-primary-deep)' : 'var(--gt-text-tertiary)',
                        boxShadow: isActive ? 'var(--gt-elev-1)' : 'none',
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                        marginBottom: -1,
                      }}
                    >
                      {label}
                    </button>
                  );
                })}
              </nav>
            </div>

            {/* Form Body */}
            <div className="overflow-y-auto max-h-[calc(90vh-160px)] p-6">
              <form onSubmit={handleSubmit} className="space-y-5">

                {/* Basic Section */}
                {activeSection === 'basic' && (
                  <div className="space-y-5 animate-in fade-in duration-300">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                        Task Title <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                        required
                        maxLength={500}
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                        autoFocus
                      />
                      <p className="text-xs text-gray-400 mt-1">{(formData.title || '').length}/500 characters</p>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-1.5">Description</label>
                      <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        rows={4}
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors resize-none"
                      />
                    </div>

                    {/* Progress & Actual Hours (edit-only fields) */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1.5">Actual Hours</label>
                        <input
                          type="number"
                          name="actual_hours"
                          value={formData.actual_hours || ''}
                          onChange={handleChange}
                          step="0.5"
                          min="0"
                          className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                          Progress <span className="text-blue-600 font-bold">{formData.progress_percent ?? 0}%</span>
                        </label>
                        <input
                          type="range"
                          name="progress_percent"
                          value={formData.progress_percent ?? 0}
                          onChange={handleChange}
                          min="0"
                          max="100"
                          className="w-full mt-2"
                        />
                      </div>
                    </div>

                    <div className="flex justify-end pt-4">
                      <button
                        type="button"
                        onClick={() => setActiveSection('details')}
                        disabled={!isBasicValid}
                        className="px-5 py-2.5 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg hover:from-blue-600 hover:to-purple-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed font-medium flex items-center gap-2 shadow-md"
                      >
                        Next: Details
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      </button>
                    </div>
                  </div>
                )}

                {/* Details Section */}
                {activeSection === 'details' && (
                  <div className="space-y-5 animate-in fade-in duration-300">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1.5">Task Type</label>
                        <div className="relative">
                          <div
                            onClick={() => setShowTypeDropdown(prev => !prev)}
                            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg cursor-pointer flex justify-between items-center bg-white"
                          >
                            <span className={formData.task_type ? "text-gray-900" : "text-gray-400"}>
                              {formData.task_type || "Select Type"}
                            </span>
                            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                            </svg>
                          </div>

                          {showTypeDropdown && (
                            <div className="absolute mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto" style={{ zIndex: 200 }}>
                              {taskTypes.map((type) => (
                                <div
                                  key={type.id}
                                  className="flex items-center justify-between px-3 py-2 hover:bg-gray-100 cursor-pointer group"
                                  onClick={() => {
                                    setFormData({ ...formData, task_type: type.name });
                                    setShowTypeDropdown(false);
                                  }}
                                >
                                  <span className="flex-1">{type.name}</span>
                                  {!type.is_default && (
                                    <div className="flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                                      <button
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleEditType(type);
                                        }}
                                        className="text-blue-500 hover:text-blue-700 p-1 rounded"
                                        title="Edit"
                                      >
                                        ✏️
                                      </button>
                                      <button
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDeleteType(type);
                                        }}
                                        className="text-red-500 hover:text-red-700 p-1 rounded"
                                        title="Delete"
                                      >
                                        🗑️
                                      </button>
                                    </div>
                                  )}
                                  {type.is_default && (
                                    <span className="text-xs text-gray-400 ml-2">Default</span>
                                  )}
                                </div>
                              ))}

                              <div
                                onClick={() => {
                                  setShowCreateTaskTypeModal(true);
                                  setShowTypeDropdown(false);
                                }}
                                className="px-3 py-2 text-blue-600 font-medium hover:bg-blue-50 cursor-pointer border-t"
                              >
                                ➕ Create New Type
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1.5">Priority</label>
                        <Select
                          value={formData.priority}
                          onValueChange={(v) => setFormData(prev => ({ ...prev, priority: v as any }))}
                        >
                          <SelectTrigger>
                            <SelectValue placeholder="Priority" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="LOW">🟢 Low</SelectItem>
                            <SelectItem value="MEDIUM">🟡 Medium</SelectItem>
                            <SelectItem value="HIGH">🟠 High</SelectItem>
                            <SelectItem value="URGENT">🔴 Urgent</SelectItem>
                          </SelectContent>
                        </Select>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {/* Due Date with Calendar Picker */}
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                          Due Date
                        </label>
                        
                        <button
                          type="button"
                          onClick={() => setDueOpen(true)}
                          className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-left flex items-center justify-between bg-white hover:bg-gray-50 transition-colors"
                        >
                          <span className="flex items-center gap-2">
                            <CalendarIcon className="h-4 w-4 text-gray-500" />
                            <span className={dueDate ? "text-gray-900" : "text-gray-400"}>
                              {dueDate ? format(dueDate, "MMM dd, yyyy HH:mm") : "Pick due date"}
                            </span>
                          </span>
                        </button>

                        {dueOpen && createPortal(
                          <div 
                            className="fixed inset-0 flex items-center justify-center bg-black/40"
                            style={{ zIndex: 120 }}
                            onClick={() => setDueOpen(false)}
                          >
                            <div 
                              className="bg-white rounded-md shadow-md w-[260px]"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <Calendar
                                mode="single"
                                selected={dueDate || undefined}
                                onSelect={handleDateSelect}
                                className="p-2 [&_.rdp-caption]:mb-0 [&_.rdp-caption_label]:text-[11px] [&_.rdp-nav_button]:w-5 [&_.rdp-nav_button]:h-5 [&_.rdp-day]:w-6 [&_.rdp-day]:h-6 [&_.rdp-day]:text-[11px] [&_.rdp-day_button]:w-6 [&_.rdp-day_button]:h-6 [&_.rdp-head_cell]:w-6 [&_.rdp-head_cell]:text-[10px]"
                              />
                              
                              <div className="flex gap-1 p-2 pt-0 border-t border-gray-100">
                                <input
                                  type="time"
                                  value={dueTime}
                                  onChange={handleTimeChange}
                                  className="flex-1 px-1 py-0.5 text-[11px] border border-gray-300 rounded"
                                />
                                <button
                                  onClick={() => {
                                    setDueDate(null);
                                    setDueTime("");
                                    setFormData((prev) => ({ ...prev, due_date: "" }));
                                    setDueOpen(false);
                                  }}
                                  className="px-2 py-0.5 text-[11px] text-gray-600 border border-gray-300 rounded hover:bg-gray-50"
                                >
                                  Clear
                                </button>
                                <button
                                  onClick={() => setDueOpen(false)}
                                  className="px-2 py-0.5 text-[11px] bg-blue-500 text-white rounded hover:bg-blue-600"
                                >
                                  OK
                                </button>
                              </div>
                            </div>
                          </div>,
                          document.body
                        )}
                      </div>

                      {/* Client Dropdown with Add Client Modal */}
                      <div>
                        <div className="flex justify-between items-center mb-1.5">
                          <label className="block text-sm font-semibold text-gray-700">Client <span className="text-gray-400 font-normal">(optional)</span></label>
                        </div>
                        <Select
                          value={(formData as any).client_id ?? "none"}
                          onValueChange={(value) => {
                            if (value === "__ADD_NEW__") {
                              setShowAddClientModal(true);
                            } else if (value === "none") {
                              setFormData((prev) => ({
                                ...prev,
                                client_id: null,
                              }));
                            } else {
                              setFormData((prev) => ({
                                ...prev,
                                client_id: value,
                              }));
                            }
                          }}
                        >
                          <SelectTrigger>
                            <SelectValue placeholder="Select Client" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="none">Select Client</SelectItem>
                            {clients.map((c) => (
                              <SelectItem key={c.id} value={c.id}>
                                {c.clientName}
                              </SelectItem>
                            ))}
                            <SelectItem value="__ADD_NEW__">➕ Add Client</SelectItem>
                          </SelectContent>
                        </Select>
                      </div>
                    </div>

                    {/* Project Dropdown */}
                    <div>
                      <div className="flex justify-between items-center mb-1.5">
                        <label className="block text-sm font-semibold text-gray-700">Project <span className="text-gray-400 font-normal">(optional)</span></label>
                      </div>
                      <Select
                        value={(formData as any).project_id ?? "none"}
                        onValueChange={(value) => {
                          if (value === "__ADD_NEW_PROJECT__") {
                            setNewProjectForm(f => ({ ...f, client_id: (formData as any).client_id || '' }));
                            setShowAddProjectModal(true);
                          } else if (value === "none") {
                            setFormData((prev) => ({ ...prev, project_id: null } as any));
                          } else {
                            const proj = projects.find(p => p.id === value);
                            setFormData((prev) => ({
                              ...prev,
                              project_id: value,
                              ...(proj?.client_id && !(prev as any).client_id ? { client_id: proj.client_id } : {}),
                            } as any));
                          }
                        }}
                      >
                        <SelectTrigger>
                          <SelectValue placeholder="Select Project" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="none">Select Project</SelectItem>
                          {projects
                            .filter(p => !(formData as any).client_id || !p.client_id || p.client_id === (formData as any).client_id)
                            .map((p) => (
                              <SelectItem key={p.id} value={p.id}>
                                {p.name}{p.client_name ? ` — ${p.client_name}` : ''}
                              </SelectItem>
                            ))}
                          <SelectItem value="__ADD_NEW_PROJECT__">➕ Add Project</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-1.5">Estimated Hours</label>
                      <input
                        type="number"
                        name="estimated_hours"
                        value={formData.estimated_hours || ''}
                        onChange={handleChange}
                        step="0.5"
                        min="0"
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                      />
                    </div>

                    <div className="flex justify-between pt-4">
                      <button
                        type="button"
                        onClick={() => setActiveSection('basic')}
                        className="px-5 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium flex items-center gap-2"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                        Back
                      </button>
                      <button
                        type="button"
                        onClick={() => setActiveSection('approval')}
                        className="px-5 py-2.5 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg hover:from-blue-600 hover:to-purple-700 transition-all font-medium flex items-center gap-2 shadow-md"
                      >
                        Next: Approval Chain
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      </button>
                    </div>
                  </div>
                )}

                {/* Approval Chain Section */}
                {activeSection === 'approval' && (
                  <div className="space-y-5 animate-in fade-in duration-300">
                    {/* Preparors */}
                    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-5 border border-blue-200">
                      <div className="flex justify-between items-center mb-3">
                        <div>
                          <div className="flex items-center gap-2">
                            <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center text-white text-xs font-bold">1</div>
                            <h3 className="font-semibold text-gray-900">Add Preparors (Workers)</h3>
                          </div>
                          <p className="text-xs text-gray-500 mt-1">Optionally add more people who will do the work</p>
                        </div>
                        <button
                          type="button"
                          onClick={addPreparor}
                          className="px-3 py-1.5 bg-blue-500 text-white text-xs rounded-lg hover:bg-blue-600 transition-colors flex items-center gap-1"
                        >
                          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                          </svg>
                          Add Preparor
                        </button>
                      </div>

                      <div className="space-y-2">
                        {selectedPreparors.length === 0 ? (
                          <button
                            type="button"
                            onClick={addPreparor}
                            className="w-full py-3 border-2 border-dashed border-blue-300 rounded-lg text-blue-600 text-sm hover:border-blue-400 hover:bg-blue-50 transition-colors"
                          >
                            + Click to add a preparor
                          </button>
                        ) : (
                          selectedPreparors.map((preparorId, idx) => (
                            <div key={idx} className="flex gap-2 items-center group">
                              <div className="w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center text-xs text-blue-600 font-medium">
                                {idx + 1}
                              </div>
                              <div className="flex-1">
                                <Select
                                  value={preparorId || "__none__"}
                                  onValueChange={(v) => updatePreparor(idx, v === "__none__" ? "" : v)}
                                  disabled={loadingUsers}
                                >
                                  <SelectTrigger>
                                    <SelectValue placeholder="Select Preparor" />
                                  </SelectTrigger>
                                  <SelectContent>
                                    <SelectItem value="__none__">— Select Preparor —</SelectItem>
                                    {users.map(user => (
                                      <SelectItem key={user.id || user.user_id || ""} value={(user.id || user.user_id) || ""}>
                                        {user.name} {user.role ? `(${user.role})` : ''}
                                      </SelectItem>
                                    ))}
                                  </SelectContent>
                                </Select>
                              </div>
                              <button
                                type="button"
                                onClick={() => removePreparor(idx)}
                                className="opacity-0 group-hover:opacity-100 p-2 bg-red-100 text-red-600 rounded-lg hover:bg-red-200 transition-all"
                              >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                              </button>
                            </div>
                          ))
                        )}
                      </div>
                    </div>

                    {/* Approval Chain */}
                    <div className="bg-gray-50 rounded-xl p-5 border border-gray-200">
                      <div className="flex justify-between items-center mb-4">
                        <div>
                          <div className="flex items-center gap-2">
                            <div className="w-6 h-6 bg-purple-500 rounded-full flex items-center justify-center text-white text-xs font-bold">2</div>
                            <h3 className="font-semibold text-gray-900">Approval Chain</h3>
                          </div>
                          <p className="text-xs text-gray-500 mt-1">Add reviewers for this task</p>
                        </div>
                        <button
                          type="button"
                          onClick={addApprovalLevel}
                          className="px-3 py-1.5 bg-purple-500 text-white text-xs rounded-lg hover:bg-purple-600 transition-colors flex items-center gap-1"
                        >
                          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                          </svg>
                          Add Level
                        </button>
                      </div>

                      <div className="space-y-3">
                        {(formData.approvalChain || []).map((level, idx) => (
                          <div key={idx} className="bg-white rounded-lg p-4 border border-gray-200">
                            <div className="flex items-center justify-between mb-3">
                              <div className="flex items-center gap-2">
                                <div className="w-6 h-6 rounded-full bg-purple-100 text-purple-600 text-xs font-bold flex items-center justify-center">
                                  {level.level}
                                </div>
                                <span className="font-medium text-gray-700">Level {level.level} Approval</span>
                              </div>
                              <button
                                type="button"
                                onClick={() => removeApprovalLevel(idx)}
                                className="text-red-500 hover:text-red-700 text-xs px-2 py-1 rounded hover:bg-red-50"
                              >
                                Remove
                              </button>
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                              <div>
                                <label className="block text-xs font-medium text-gray-600 mb-1">Who Will Approve</label>
                                <Select
                                  value={level.approver || "__none__"}
                                  onValueChange={(v) => updateApprovalLevel(idx, 'approver', v === "__none__" ? "" : v)}
                                  disabled={loadingUsers}
                                >
                                  <SelectTrigger>
                                    <SelectValue placeholder="Select" />
                                  </SelectTrigger>
                                  <SelectContent>
                                    <SelectItem value="__none__">— Select —</SelectItem>
                                    {users.map(user => (
                                      <SelectItem key={user.id || user.user_id || ""} value={(user.id || user.user_id) || ""}>
                                        {user.name} {user.role ? `(${user.role})` : ''}
                                      </SelectItem>
                                    ))}
                                  </SelectContent>
                                </Select>
                              </div>
                              <div>
                                <label className="block text-xs font-medium text-gray-600 mb-1">Role Label</label>
                                <input
                                  type="text"
                                  value={level.roleLabel}
                                  onChange={e => updateApprovalLevel(idx, 'roleLabel', e.target.value)}
                                  placeholder="e.g., Accounts Reviewer"
                                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 text-sm"
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="flex justify-between pt-4">
                      <button
                        type="button"
                        onClick={() => setActiveSection('details')}
                        className="px-5 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium flex items-center gap-2"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                        Back
                      </button>
                      <button
                        type="button"
                        onClick={() => setActiveSection('checklist')}
                        className="px-5 py-2.5 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg hover:from-blue-600 hover:to-purple-700 transition-all font-medium flex items-center gap-2 shadow-md"
                      >
                        Next: Checklist
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      </button>
                    </div>
                  </div>
                )}

                {/* Checklist Section */}
                {activeSection === 'checklist' && (
                  <div className="space-y-5 animate-in fade-in duration-300">
                    <div>
                      <div className="flex justify-between items-center mb-2">
                        <label className="block text-sm font-semibold text-gray-700">Checklist Items</label>
                        <span className="text-xs text-gray-400">
                          {checklistItems.filter(i => i.trim()).length} item(s)
                        </span>
                      </div>
                      {checklistItems.length === 0 && (
                        <p className="text-sm text-gray-400 italic mb-2">No checklist items yet. Click below to add.</p>
                      )}
                      <div className="space-y-2 max-h-64 overflow-y-auto pr-2">
                        {checklistItems.map((item, index) => (
                          <div key={index} className="flex gap-2 items-center group">
                            <div className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center text-xs text-gray-500">
                              {index + 1}
                            </div>
                            <input
                              type="text"
                              value={item}
                              onChange={e => handleChecklistChange(index, e.target.value)}
                              placeholder={`Task item ${index + 1}`}
                              className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                            />
                            <button
                              type="button"
                              onClick={() => removeChecklistItem(index)}
                              className="opacity-0 group-hover:opacity-100 p-2 bg-red-100 text-red-600 rounded-lg hover:bg-red-200 transition-all"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                              </svg>
                            </button>
                          </div>
                        ))}
                      </div>
                      <button
                        type="button"
                        onClick={addChecklistItem}
                        className="mt-3 text-blue-600 hover:text-blue-700 text-sm font-medium flex items-center gap-1"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                        </svg>
                        Add Checklist Item
                      </button>
                    </div>

                    {/* Summary */}
                    <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl p-4 border border-green-200">
                      <h4 className="font-semibold text-gray-800 text-sm mb-2">📋 Update Summary</h4>
                      <div className="space-y-1 text-xs text-gray-600">
                        <p><strong>Title:</strong> {formData.title || 'Not set'}</p>
                        <p><strong>Priority:</strong> {formData.priority || 'Not set'}</p>
                        <p><strong>Preparors:</strong> {selectedPreparors.filter(p => p).length > 0 ? selectedPreparors.filter(p => p).map(p => getUserName(p)).join(', ') : 'None'}</p>
                        <p><strong>Reviewers:</strong> {(formData.approvalChain || []).filter(l => l.approver).length}</p>
                        <p><strong>Checklist Items:</strong> {checklistItems.filter(i => i.trim()).length}</p>
                      </div>
                    </div>

                    <div className="flex justify-between pt-4">
                      <button
                        type="button"
                        onClick={() => setActiveSection('approval')}
                        className="px-5 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium flex items-center gap-2"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                        Back
                      </button>
                      <div className="flex gap-3">
                        <button
                          type="button"
                          onClick={onClose}
                          className="px-5 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium"
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          disabled={loading || !isBasicValid}
                          className="px-6 py-2.5 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed font-medium flex items-center gap-2 shadow-md"
                        >
                          {loading ? (
                            <>
                              <svg className="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                              </svg>
                              Saving...
                            </>
                          ) : (
                            <>
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                              </svg>
                              Save Changes
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Create Task Type Modal */}
      {showCreateTaskTypeModal && (
        <>
          <div
            className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[110]"
            onClick={() => setShowCreateTaskTypeModal(false)}
          />
          <div className="fixed inset-0 z-[110] overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4">
              <div
                className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md animate-in fade-in zoom-in duration-300"
                onClick={e => e.stopPropagation()}
              >
                <div className="p-6">
                  <div className="flex justify-between items-center mb-4">
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 bg-gradient-to-r from-purple-500 to-pink-500 rounded-xl flex items-center justify-center shadow-md">
                        <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l5 5a2 2 0 01.586 1.414V19a2 2 0 01-2 2H7a2 2 0 01-2-2V5a2 2 0 012-2z" />
                        </svg>
                      </div>
                      <h3 className="text-lg font-bold text-gray-900">Create Task Type</h3>
                    </div>
                    <button onClick={() => setShowCreateTaskTypeModal(false)} className="p-1 hover:bg-gray-100 rounded-lg">
                      <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                        Type Name <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        value={newTaskTypeName}
                        onChange={e => setNewTaskTypeName(e.target.value)}
                        placeholder="e.g., Documentation, Research, Testing"
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-colors"
                        autoFocus
                        onKeyPress={e => { if (e.key === 'Enter') handleCreateTaskType(); }}
                      />
                    </div>
                    <div className="flex gap-3 pt-4">
                      <button
                        type="button"
                        onClick={() => setShowCreateTaskTypeModal(false)}
                        className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        onClick={handleCreateTaskType}
                        disabled={creatingTaskType || !newTaskTypeName.trim()}
                        className="flex-1 px-4 py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg hover:from-purple-600 hover:to-pink-600 transition-all disabled:opacity-50 font-medium flex items-center justify-center gap-2 shadow-md"
                      >
                        {creatingTaskType ? (
                          <>
                            <svg className="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                            </svg>
                            Creating...
                          </>
                        ) : (
                          <>
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                            Create Type
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Edit Task Type Modal */}
      {showEditModal && editingType && (
        <>
          <div
            className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[110]"
            onClick={() => setShowEditModal(false)}
          />
          <div className="fixed inset-0 z-[110] overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4">
              <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md animate-in fade-in zoom-in duration-300">
                <div className="p-6">
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-bold text-gray-900">Edit Task Type</h3>
                    <button onClick={() => setShowEditModal(false)} className="p-1 hover:bg-gray-100 rounded-lg">
                      <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                  <input
                    type="text"
                    value={editName}
                    onChange={e => setEditName(e.target.value)}
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg mb-4"
                    autoFocus
                  />
                  <div className="flex gap-3">
                    <button onClick={() => setShowEditModal(false)} className="flex-1 px-4 py-2 border rounded-lg">Cancel</button>
                    <button onClick={handleUpdateTaskType} className="flex-1 px-4 py-2 bg-blue-500 text-white rounded-lg">Update</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && deleteType && (
        <>
          <div
            className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[110]"
            onClick={() => setShowDeleteModal(false)}
          />
          <div className="fixed inset-0 z-[110] overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4">
              <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md animate-in fade-in zoom-in duration-300">
                <div className="p-6">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Delete Task Type</h3>
                  <p className="text-gray-700 mb-4">Are you sure you want to delete "{deleteType.name}"?</p>
                  <div className="flex gap-3">
                    <button onClick={() => setShowDeleteModal(false)} className="flex-1 px-4 py-2 border rounded-lg">Cancel</button>
                    <button onClick={handleDeleteTaskType} className="flex-1 px-4 py-2 bg-red-500 text-white rounded-lg">Delete</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Quick Add Client Modal - Device Friendly */}
      {showAddClientModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[110] flex items-start sm:items-center justify-center p-2 sm:p-4 overflow-y-auto" onClick={() => setShowAddClientModal(false)}>
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
            <div className="sticky top-0 bg-white z-10 p-5 border-b border-gray-100 flex items-center gap-3">
              <div className="w-9 h-9 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center">
                <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0M12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <div>
                <h3 className="font-bold text-gray-900">Add New Client</h3>
                <p className="text-xs text-gray-500">Quick add — full details in Client panel</p>
              </div>
            </div>
            <div className="p-5 space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Client Name <span className="text-red-500">*</span></label>
                <input type="text" value={newClientForm.clientName} onChange={e => setNewClientForm(f => ({ ...f, clientName: e.target.value }))}
                  placeholder="e.g., Acme Corporation" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm" autoFocus />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                  <input type="email" value={newClientForm.email} onChange={e => setNewClientForm(f => ({ ...f, email: e.target.value }))}
                    placeholder="email@co.com" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
                  <input type="tel" value={newClientForm.phone} onChange={e => setNewClientForm(f => ({ ...f, phone: e.target.value }))}
                    placeholder="+91..." className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Address Line 1</label>
                <input type="text" value={newClientForm.address1} onChange={e => setNewClientForm(f => ({ ...f, address1: e.target.value }))}
                  placeholder="Street address" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Address Line 2</label>
                <input type="text" value={newClientForm.address2} onChange={e => setNewClientForm(f => ({ ...f, address2: e.target.value }))}
                  placeholder="Area, landmark…" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm" />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">State</label>
                  <input type="text" value={newClientForm.state} onChange={e => setNewClientForm(f => ({ ...f, state: e.target.value }))}
                    placeholder="State" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Country</label>
                  <input type="text" value={newClientForm.country} onChange={e => setNewClientForm(f => ({ ...f, country: e.target.value }))}
                    placeholder="Country" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Pincode</label>
                  <input type="text" value={newClientForm.pincode} onChange={e => setNewClientForm(f => ({ ...f, pincode: e.target.value }))}
                    placeholder="000000" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm" />
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-1 border-t border-gray-100">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">GSTIN</label>
                  <input type="text" value={newClientForm.gstin} onChange={e => setNewClientForm(f => ({ ...f, gstin: e.target.value.toUpperCase() }))}
                    placeholder="22AAAAA0000A1Z5" maxLength={15}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm font-mono" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">PAN</label>
                  <input type="text" value={newClientForm.pan} onChange={e => setNewClientForm(f => ({ ...f, pan: e.target.value.toUpperCase() }))}
                    placeholder="AAAAA0000A" maxLength={10}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm font-mono" />
                </div>
              </div>
            </div>
            <div className="sticky bottom-0 bg-white p-5 border-t border-gray-100 flex gap-3 justify-end">
              <button onClick={() => setShowAddClientModal(false)} className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 text-sm font-medium">Cancel</button>
              <button onClick={handleSaveNewClient} disabled={savingClient || !newClientForm.clientName.trim()}
                className="px-5 py-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg hover:from-indigo-700 hover:to-purple-700 transition-all text-sm font-medium disabled:opacity-50">
                {savingClient ? 'Adding…' : 'Add Client'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Quick Add Project Modal */}
      {showAddProjectModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[110] flex items-start sm:items-center justify-center p-2 sm:p-4 overflow-y-auto" onClick={() => setShowAddProjectModal(false)}>
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md" onClick={e => e.stopPropagation()}>
            <div className="p-5 border-b border-gray-100 flex items-center gap-3">
              <div className="w-9 h-9 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl flex items-center justify-center">
                <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V7z" />
                </svg>
              </div>
              <div>
                <h3 className="font-bold text-gray-900">Add New Project</h3>
                <p className="text-xs text-gray-500">Quick add — manage details in Projects panel</p>
              </div>
            </div>
            <div className="p-5 space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Project Name <span className="text-red-500">*</span></label>
                <input type="text" value={newProjectForm.name} onChange={e => setNewProjectForm(f => ({ ...f, name: e.target.value }))}
                  placeholder="e.g., Website Redesign" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm" autoFocus />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Client (optional)</label>
                <Select
                  value={newProjectForm.client_id || "__none__"}
                  onValueChange={(v) => setNewProjectForm(f => ({ ...f, client_id: v === "__none__" ? "" : v }))}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select Client" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="__none__">— No client —</SelectItem>
                    {clients.map(c => <SelectItem key={c.id} value={c.id}>{c.clientName}</SelectItem>)}
                  </SelectContent>
                </Select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                <textarea value={newProjectForm.description} onChange={e => setNewProjectForm(f => ({ ...f, description: e.target.value }))}
                  rows={2} placeholder="Brief description..." className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm" />
              </div>
            </div>
            <div className="p-5 border-t border-gray-100 flex gap-3 justify-end">
              <button onClick={() => setShowAddProjectModal(false)} className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 text-sm font-medium">Cancel</button>
              <button onClick={handleSaveNewProject} disabled={savingProject || !newProjectForm.name.trim()}
                className="px-5 py-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg hover:from-blue-600 hover:to-purple-700 transition-all text-sm font-medium disabled:opacity-50">
                {savingProject ? 'Adding…' : 'Add Project'}
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes zoomIn { from { transform: scale(0.95); opacity: 0; } to { transform: scale(1); opacity: 1; } }
        .animate-in { animation-duration: 0.3s; animation-fill-mode: both; }
        .fade-in { animation-name: fadeIn; }
        .zoom-in { animation-name: zoomIn; }
      `}</style>
    </div>,
    document.body
  );
}

export default TaskEdit;
